import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import TextBoxClient from 'client/components/TextBoxClient';
import { useDispatch } from 'react-redux';
import { updateFirstPassLoginSeverStatus } from 'client/redux/modules/promoState';
import useGenerateState from 'client/hooks/useGenerateState';
import CoverFgImage from 'components/CoverPage/CoverFgImage';
import { bgTypes } from 'styles/generateBgStyleByType';
import useCoverSettingComponentStyle from 'hooks/useCoverSettingComponentStyle';

export default function Game({ onGameFinish }) {
    const dispatch = useDispatch();
    const { isAfterReduceFeverPoint, isFirstPassLogin, isAfterVerifyPasscode } = useGenerateState();
    const coverPageContent = useSelector(s => s.settingGame.coverPageContent);
    const coverSettingStyle = useCoverSettingComponentStyle();
    const isFgImageOnly = coverSettingStyle.foregroundTab === bgTypes.IMG;

    useEffect(() => {
        if (isFirstPassLogin) {
            dispatch(updateFirstPassLoginSeverStatus());
            onGameFinish();
        } else if (isAfterReduceFeverPoint) {
            onGameFinish();
        } else if (isAfterVerifyPasscode) {
            onGameFinish();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFirstPassLogin, isAfterReduceFeverPoint, isAfterVerifyPasscode]);

    if (isFgImageOnly) {
        return (
            <CoverFgImage
                desktopImage={coverSettingStyle.foregroundDesktopImg}
                mobileImage={coverSettingStyle.foregroundMobileImg}
                onClick={onGameFinish}
                isEditor={false}
            />
        );
    }

    return (
        <TextBoxClient
            style={{ backgroundColor: 'transparent', cursor: 'pointer' }}
            content={coverPageContent}
            onClick={onGameFinish}
            ignoreContentPadding
            shouldUseCompressedImg
        />
    );
}

Game.propTypes = {
    onGameFinish: PropTypes.func
};
